import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { store } from 'app/shared/store/store';
import { authenticationService } from 'app/shared/services/authentication/authentication.service';
import { locationService } from 'app/shared/services/location/location-service';

@Component({
  tag: 'login-to-account',
  styleUrl: 'login-to-account.scss'
})
export class LoginToAccount implements ComponentInterface {
  @Prop() public buttonText = 'Log in to your AGL account';

  public componentWillLoad(): void {
    if (this.isLoggedIn() && store.get('isAuthenticated')) {
      locationService.navigateToProductBundle();
    }
  }

  public navigateExistingCustomer(): void {
    authenticationService.login();
  }

  public render(): JSX.Element {
    return (
      <Host>
        {this.isAuthenticatedFlowEnabled() && !this.isLoggedIn() && (
          <div class="login-to-account">
            <div class="login-to-account__mid-text">
              <agl-ds-text font-weight="semibold" styled-as="lg">
                Or
              </agl-ds-text>
            </div>
            <div class="login-to-account__cta">
              <agl-ds-button type="primary" sr-context={this.buttonText} onClick={this.navigateExistingCustomer}>
                {this.buttonText}
              </agl-ds-button>
            </div>
          </div>
        )}
      </Host>
    );
  }

  private isLoggedIn(): boolean {
    return authenticationService.loggedIn;
  }

  private isAuthenticatedFlowEnabled(): boolean {
    return window.sessionStorage.getItem('authenticatedGuidedFlowEnabled')?.includes('true');
  }
}
